import { selectFinancialYear } from 'legacy/lut/features/partner360/configuration'
import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { useSelector } from 'react-redux'

export const isMdfActivityReadOnly = (
  selectedFYear: number | undefined,
  currentFYear: number | undefined
): boolean => Boolean(selectedFYear && currentFYear && selectedFYear < currentFYear)

export const useIsMdfActivityReadOnly = (fYearOverride?: number): boolean => {
  const selectedFYear = useSelector(selectFinancialYear)
  const currentFYear = useSelector(selectJBPSettingsCurrentFYear)

  return isMdfActivityReadOnly(fYearOverride ?? selectedFYear, currentFYear)
}
